"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Button, Stack, Text } from "@leabankab/component-library";
import { WaitingPage } from "@/components/waiting-page";
import { useRuntimeConfig } from "@/contexts/runtime-config";
import { logError } from "@/datadog/logger";
import { useCountrySettings } from "@/hooks/use-app-country";

export default function Error({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	const router = useRouter();
	const mockMode = useRuntimeConfig().devConsole;
	const errorUrl = useCountrySettings().receiptUrls.error;

	useEffect(() => {
		logError("Client error boundary", error, { digest: error.digest });

		if (mockMode) {
			return;
		}

		const timeout = setTimeout(() => {
			router.push(errorUrl);
		}, 500);

		return () => clearTimeout(timeout);
	}, [error, errorUrl, mockMode, router]);

	if (mockMode) {
		return (
			<Stack
				gap={2}
				style={{
					margin: "auto",
					maxWidth: 480,
					padding: 4,
					textAlign: "center",
				}}
			>
				<Text render={<h2 />} textStyle="heading-lg">
					Something went wrong (dev mode)
				</Text>
				<Text render={<p />} textStyle="body-md" color="text.subtle">
					{error.message}
				</Text>
				<Stack direction="row" gap={1} justify="center">
					<Button onClick={reset}>Retry</Button>
					<Button variant="outline" onClick={() => router.push("/")}>
						Back to start
					</Button>
				</Stack>
			</Stack>
		);
	}

	return <WaitingPage />;
}
